"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultEmailTemplate = void 0;
const enums_1 = require("../enums");
const getDefaultEmailTemplateKey = ({ emailType, formType, formCategory, }) => {
    switch (emailType) {
        case enums_1.EmailContentType.INVITATION: {
            if (formType === enums_1.FormType.DonationForm) {
                return "fundraising";
            }
            if (formType === enums_1.FormType.Ticketing) {
                return "invitation";
            }
            break;
        }
        case enums_1.EmailContentType.REMINDER:
            if (formCategory === enums_1.FormCategory.Auction) {
                return "auctionReminder";
            }
            return "eventReminder";
        case enums_1.EmailContentType.FOLLOW_UP: {
            if (formType === enums_1.FormType.Ticketing) {
                return "ticketingFollowUp";
            }
            if (formType === enums_1.FormType.DonationForm) {
                return "donationFormFollowUp";
            }
            break;
        }
        case enums_1.EmailContentType.POST_EVENT:
            return "eventRecap";
        default:
            return undefined;
    }
    return undefined;
};
const getDefaultEmailTemplate = ({ emailType, formType, formCategory, }) => {
    return {
        templateKey: getDefaultEmailTemplateKey({ emailType, formType, formCategory }) ?? undefined,
    };
};
exports.getDefaultEmailTemplate = getDefaultEmailTemplate;
